<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        role="presentation"
        :aria-labelledby="icon"
        class="pt-icon"
    >
        <use :xlink:href="['#' + icon]" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'PtIcon',

    props: {
        icon: String,
    }
});
</script>
